/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { userLeaveOrganisation } from '../../axios/userLeaveOrganisation'
import type {
	UserLeaveOrganisationError,
	UserLeaveOrganisationRequest,
	UserLeaveOrganisationResponse,
} from '../../types/UserLeaveOrganisation'

export const userLeaveOrganisationMutationKey = () => [{ url: '/users/leave-organisation' }] as const

export type UserLeaveOrganisationMutationKey = ReturnType<typeof userLeaveOrganisationMutationKey>

export type UserLeaveOrganisationVariables = {
	data: UserLeaveOrganisationRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::leaveOrganisation */
export function useUserLeaveOrganisation<TContext = unknown>(
	options?: UseMutationOptions<
		UserLeaveOrganisationResponse,
		AxiosError<UserLeaveOrganisationError>,
		UserLeaveOrganisationVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: userLeaveOrganisationMutationKey(),
		mutationFn: ({ data }: UserLeaveOrganisationVariables) =>
			userLeaveOrganisation(data, config).then(res => res.data),
		...options,
	})
}
